import { Component } from '@angular/core';
import {  OnDestroy, Inject, ChangeDetectorRef, ViewChild } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatCalendar, MatDatepicker } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats, MAT_DATE_LOCALE } from '@angular/material/core';
import { BehaviorSubject } from 'rxjs';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { formatDate } from '@angular/common';
import { SharedTranslateModule } from '../../../utils/sharedTranslateModule';


@Component({
    selector: 'div.dtf-customdatepicker',
    imports: [SharedTranslateModule, MatMenuModule],
    templateUrl: './custom-date-picker.component.html'
})
export class CustomDatePickerComponent implements OnDestroy {
  private _destroyed = new Subject();
  closeCalendarSource = new BehaviorSubject<boolean>(false);
  isListOpen = false;

  itemList = [];
  private mouseHoldTimeout: any;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  @ViewChild(MatMenuTrigger) triggerPrevious: MatMenuTrigger;
    monthList: string[]=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    mode: string;
    previousBoolean: boolean;
    nextBoolean: boolean;
  constructor(
      private _datePicker: MatDatepicker<'D'>,
      private _calendar: MatCalendar<'D'>,
      private _dateAdapter: DateAdapter<'D'>,
      @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats,
      @Inject(MAT_DATE_LOCALE) private dateLocale:string,
      cdr: ChangeDetectorRef,
  ) {
      _calendar.stateChanges.pipe(takeUntil(this._destroyed)).subscribe(() => cdr.markForCheck());
  }

  ngOnDestroy() {
      //    this._destroyed.next();
      //    this._destroyed.complete();
  }
  ngOnInit(){
      this._dateAdapter.setLocale(this.dateLocale);
      this._dateAdapter.getFirstDayOfWeek=()=>1;
      this._dateAdapter.getDayOfWeekNames('long')
  }

//   to disaply today button in calender
  get periodLabel() {
      return this._dateAdapter
          .format(this._calendar.activeDate, this._dateFormats.display.monthYearA11yLabel)

  }

//   this method get called on click previous button (<) (<<) in calender to change the either month or year
  previousClicked(mode: 'month' | 'year') {
      this._calendar.activeDate =
          mode === 'month'
              ? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1)
              : this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
  }
//   this method get called on click next button (>) (>>) in calender to change the either month or year
  nextClicked(mode: 'month' | 'year') {
      
      this._calendar.activeDate =
          mode === 'month'
              ? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1)
              : this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
  }

//   this method get call on click ? in calender which open the alter with info related to calender
  infoClicked() {
      alert("DHTML/Time Selector \n(c) dynarch.com 2002-2003\nfor the latest version visit:http://dynarch.com/mishoo/calendar.epl \nDistributed under GNU LGPL, See http://gnu.org/license/lgpl.html \nfor details\nDate selection:\n- Use <<,>> buttons to select year\n- Use <, > buttons to select month\n- Hold mouse button on any of the of the above buttons for the faster selection.")
  }

//   this methos is called on click today button in calender
  setTodayDate() {
      this._calendar.activeDate =
          this._dateAdapter.today();
      // this._calendar._dateSelected(this._calendar.activeDate);
      this._datePicker.select(this._dateAdapter.today());

  }
//   this method is called on click x in calender to close the calender
  closeCalendar() {
      this._datePicker.close();
  }

//   this method get called on mouse hold on > or >> button for showing month or year list for 
  onMouseDown(event: MouseEvent, mode: 'month' | 'year') {

this.previousBoolean=false
this.nextBoolean=true;
if(mode==='month'){
    this.itemList=this.monthList
     this.mode='month'

}else{
     this.mode='year'
    let startYear=formatDate((this._calendar.activeDate),'yyyy','en-US')
    let yearList=[]
    for(let i=1;i<=12;i++){
      yearList.push(Number(startYear)+i)
    }
    this.itemList=yearList
}
     this.mouseHoldTimeout = setTimeout(() => {

      this.isListOpen = true;
      this.trigger.openMenu();
      
       }, 500 ); // Adjust the hold time as needed (in milliseconds)
  }
  onMouseUp() {
  
    clearTimeout(this.mouseHoldTimeout);

    this.isListOpen = false;
    this.trigger.closeMenu();

  }

//    this method get called on mouse hold on < or << button for showing month or year list for 
  onMouseDownPrevious(event: MouseEvent, mode: 'month' | 'year') {
    
    this.nextBoolean=false;
   this.previousBoolean=true;
    if(mode==='month'){
        this.itemList=this.monthList
         this.mode='month'
    
    }else{
         this.mode='year'
        let startYear=formatDate((this._calendar.activeDate),'yyyy','en-US')
        let yearList=[]
        for(let i=1;i<=12;i++){
          yearList.push(Number(startYear)-i)
        }
        this.itemList=yearList
    }
         this.mouseHoldTimeout = setTimeout(() => {
    
          this.isListOpen = true;
          this.triggerPrevious.openMenu();
          
           }, 500 ); // Adjust the hold time as needed (in milliseconds)
      }

    // this method get called on click or any month or year from the list  
  onClickItem(item,index){
      let year=formatDate((this._calendar.activeDate),'yyyy','en-US')
      let month=formatDate((this._calendar.activeDate),'MM','en-US')
      let day=formatDate((this._calendar.activeDate),'dd','en-US')
      if(this.mode==='year'){
        this._calendar.activeDate =this._dateAdapter.createDate(item,Number(month),Number(day))
        this._datePicker.select(this._dateAdapter.createDate(item,Number(month),Number(day)))
     }else{
        this._calendar.activeDate =this._dateAdapter.createDate(Number(year),index,Number(day))
        this._datePicker.select(this._dateAdapter.createDate(Number(year),index,Number(day)))
     }
  }
}

